export const hasRole = ({ roles, functionId, roleId }) => roles.some((role) => roleId === role.roleId && functionId === role.functionId && role.endDate === null)

export const hasRoleCeased = ({ roles, functionId, roleId }) => roles.some((role) => roleId === role.roleId && functionId === role.functionId && role.endDate !== null)
